import styles from './PlatformVersionAdd.module.scss'
import api from 'helpers/api'
import React, {useEffect, useState} from 'react'
import MultiSelectWithValidation from "../../miscellaneous/MultiSelectWithValidation/MultiSelectWithValidation";
import InputWithValidation from "../../miscellaneous/InputWithValidation/InputWithValidation";
import _ from "lodash";
import {$t} from "../../../helpers/translator";

const PlatformVersionAdd = (props) => {
    const [loading, setLoading] = useState(false);
    const [formSent, setFormSent] = useState(false);
    const [formSubmissionError, setFormSubmissionError] = useState('');

    const [platformType, setPlatformType] = useState({value: null, errors: []});
    const [module, setModule] = useState({value: '', errors: []});
    const [version, setVersion] = useState({value: '', errors: []});
    const [countryGroup, setCountryGroup] = useState({value: null, errors: []});
    const [addedBy, setAddedBy] = useState({value: '', errors: []});

    const acceptedPlatformModules = [
        {
            value: 1,
            label: 'Soprano',
            modules: ['screen_version', 'controller_version', 'secondary_controller_version']
        },
    ]
    const [moduleOptions, setModuleOptions] = useState([]);
    const [countryGroupOptions, setCountryGroupOptions] = useState([
        {
            value: 1,
            label: 'Other (1)',
        },
        {
            value: 2,
            label: 'Japan (2)',
        }
    ]);

    useEffect(() => {

    }, [])

    function resetForm() {
        // console.log('reset ?')
        // setPlatformType({value: null, errors: []});
        // setModule({value: '', errors: []});
        // setVersion({value: '', errors: []});
        // setCountryGroup({value: null, errors: []});
        // setAddedBy({value: '', errors: []});
        // setFormSubmissionError('');
    }

    async function postNewVersion() {
        setFormSubmissionError('');
        setFormSent(true)

        //validating:
        let errorCount =
            platformType.errors.length +
            module.errors.length +
            version.errors.length +
            countryGroup.errors.length +
            addedBy.errors.length;


        if (errorCount) {
            return;
        }

        try {
            let payload = {
                machine_type: platformType.value.value,
                equipment: module.value.value,
                version: version.value,
                country_group: countryGroup.value.value,
                added_by_name: addedBy.value
            }

            let res = await api.post(`platform/version`, payload);
            // console.log(res)
            if (res && res.success) {
                props.onNewVersionAdded({success: true});
                resetForm();
            } else {
                setFormSubmissionError(res.errorText ? res.errorText : 'Unknown error occurred');
            }

        } catch (e) {
            console.error(e);
        }
    }

    async function platformTypeSelectedHandler(data) {
        setPlatformType(data);
        let moduleOptions = [];
        _.forEach(data.value.modules, (v, k) => {
            moduleOptions.push({
                value: v,
                label: v
            })
        })
        setModuleOptions(moduleOptions)
    }

    return (
        <div>
            <div className={`${styles['fields-row']}`}>
                <div className={'alma-field-container'}>
                    <div className={'alma-field-header'}>
                        {$t('global.machines.versions.platformType')}
                    </div>
                    <MultiSelectWithValidation
                        required
                        touched={formSent}
                        searchable={false}
                        options={acceptedPlatformModules}
                        selected={platformType.value}
                        onValueChange={(data) => platformTypeSelectedHandler(data)}
                    />
                </div>

                <div className={'alma-field-container'}>
                    <div className={'alma-field-header'}>
                        {$t('global.machines.versions.module')}
                    </div>
                    <MultiSelectWithValidation
                        required
                        touched={formSent}
                        searchable={false}
                        options={moduleOptions}
                        selected={module.value}
                        // disabled={!!platformType.value}
                        onValueChange={(data) => setModule(data)}
                    />
                </div>

                <div className={'alma-field-container'}>
                    <div className={'alma-field-header'}>
                        {$t('global.machines.versions.countryGroup')}
                    </div>
                    <MultiSelectWithValidation
                        // tooltip="Make sure you don't make a mistake here"
                        required
                        touched={formSent}
                        searchable={false}
                        options={countryGroupOptions}
                        selected={countryGroup.value}
                        onValueChange={(data) => setCountryGroup(data)}
                    />
                </div>

                <div className={'alma-field-container'}>
                    <div className={'alma-field-header'}>
                        {$t('global.machines.versions.newVersion')}
                    </div>
                    <InputWithValidation
                        name="version"
                        tooltip={$t('global.machines.versions.beCareful')}
                        validations={['required']}
                        onChange={(data) => {
                            setVersion(data)
                            // console.log(data)
                        }}
                        touched={formSent}
                        type="text"
                        value={version.value}
                        placeholder={$t('global.machines.versions.versionNameOrNumber')}
                    />

                </div>

                <div className={'alma-field-container'}>
                    <div className={'alma-field-header'}>
                        {$t('global.machines.versions.addedBy')}
                    </div>
                    <InputWithValidation
                        name="addedBy"
                        tooltip="For example: 'Yan'"
                        validations={['required', 'minLength(3)']}
                        onChange={(data) => setAddedBy(data)}
                        touched={formSent}
                        type="text"
                        value={addedBy.value}
                        placeholder={'Yan'}
                    />
                </div>

                <div className={'fields-row'}>
                    <div className={'field-container'}>
                        <div className={'alma-button'}
                             onClick={async () => await postNewVersion()}>
                            {$t('global.machines.versions.addVersion')}
                        </div>
                    </div>
                </div>

                <div className={styles.responseError}>
                    {formSubmissionError}
                </div>
            </div>
        </div>
    )
}


export default PlatformVersionAdd;